import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceSummaryType  {
    _originalTypeClassName = "zERP.BO.InvoiceSummaryType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceSummaryType.translate = translateService;
}
this.IncomeClassification = [];
this.ExpensesClassification = [];
this.Id = null;
this.TotalNetValue = null;
this.TotalVatAmount = null;
this.TotalTaxesAmount = null;
this.TotalWithheldAmount = null;
this.TotalFeesAmount = null;
this.TotalStampDutyAmount = null;
this.TotalOtherTaxesAmount = null;
this.TotalDeductionsAmount = null;
this.TotalGrossValue = null;
this.TotalDeductionsValue = null;
this.TotalGrossValueWithDeductions = null;
this.ERPAA = null;
this.ERPDocID = null;
this.NonPrepaidWithheldAmount = null;
this.PrepaidWithheldAmount = null;
this.NonPrepaidDeductionsAmount = null;
this.PrepaidDeductionsAmount = null;
this.TotalNonPrepaidWithheldAmount = null;
this.IsReadOnly = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TotalNetValue:any;
TotalVatAmount:any;
TotalTaxesAmount:any;
TotalWithheldAmount:any;
TotalFeesAmount:any;
TotalStampDutyAmount:any;
TotalOtherTaxesAmount:any;
TotalDeductionsAmount:any;
TotalGrossValue:any;
TotalDeductionsValue:any;
TotalGrossValueWithDeductions:any;
ERPAA:any;
ERPDocID:any;
NonPrepaidWithheldAmount:any;
PrepaidWithheldAmount:any;
NonPrepaidDeductionsAmount:any;
PrepaidDeductionsAmount:any;
TotalNonPrepaidWithheldAmount:any;
IsReadOnly:any;
IncomeClassification:any;
ExpensesClassification:any;
ERPInvoiceCategory:any;
ERPInvoiceType:any;
static setIncomeClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeClassification == null) $this.IncomeClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeClassification.length > 0) {
                    Domain.InvoiceSummaryType.removeIncomeClassification($this, $this.IncomeClassification[0]);
                }

                Domain.InvoiceSummaryType.addManyIncomeClassification($this, copyItems);
            }
static addManyIncomeClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceSummaryType.addIncomeClassification($this, items[i]);
                }
            }
static addIncomeClassification = ($this, item) => {
                if ($this.IncomeClassification == null) $this.IncomeClassification = [];
                if (item == null || $this.IncomeClassification.indexOf(item) > -1) return;
                $this.IncomeClassification.push(item);
if (item.InvoiceSummaryType != $this) {
Domain.IncomeClassificationType.setInvoiceSummaryType(item, $this);
}
}
static addRangeIncomeClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceSummaryType.addIncomeClassification($this, item));
            }
static removeIncomeClassification = ($this, item) => {
                if ($this == null || $this.IncomeClassification == null || $this.IncomeClassification.indexOf(item) === -1) return;
                var _index = $this.IncomeClassification.indexOf(item);
                $this.IncomeClassification.splice(_index, 1);
item.InvoiceSummaryType = null;
}
static clearIncomeClassification = ($this) => { $this.IncomeClassification = null; }
static setExpensesClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesClassification == null) $this.ExpensesClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesClassification.length > 0) {
                    Domain.InvoiceSummaryType.removeExpensesClassification($this, $this.ExpensesClassification[0]);
                }

                Domain.InvoiceSummaryType.addManyExpensesClassification($this, copyItems);
            }
static addManyExpensesClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceSummaryType.addExpensesClassification($this, items[i]);
                }
            }
static addExpensesClassification = ($this, item) => {
                if ($this.ExpensesClassification == null) $this.ExpensesClassification = [];
                if (item == null || $this.ExpensesClassification.indexOf(item) > -1) return;
                $this.ExpensesClassification.push(item);
if (item.InvoiceSummaryType != $this) {
Domain.ExpensesClassificationType.setInvoiceSummaryType(item, $this);
}
}
static addRangeExpensesClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceSummaryType.addExpensesClassification($this, item));
            }
static removeExpensesClassification = ($this, item) => {
                if ($this == null || $this.ExpensesClassification == null || $this.ExpensesClassification.indexOf(item) === -1) return;
                var _index = $this.ExpensesClassification.indexOf(item);
                $this.ExpensesClassification.splice(_index, 1);
item.InvoiceSummaryType = null;
}
static clearExpensesClassification = ($this) => { $this.ExpensesClassification = null; }
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}

static GetTotalDeductionsValue($this: any): any{return Joove.Common.safeNumber($this?.TotalWithheldAmount) + Joove.Common.safeNumber($this?.TotalDeductionsAmount);
}
static GetTotalNonPrepaidWithheldAmount($this: any): any{return Joove.Common.safeNumber($this?.NonPrepaidWithheldAmount) + Joove.Common.safeNumber($this?.NonPrepaidDeductionsAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}